// extracted by mini-css-extract-plugin
module.exports = {"logo-wrapper":"PulsingLogo_logo-wrapper__AHkhs","logo":"PulsingLogo_logo__sR522","pulse":"PulsingLogo_pulse__kAvx9"};